export const BASE_BANNER_CONSTANTS = {
    viewBreakpoints: {
        mobile: 767,
        desktop: 768
    },
    ariaLabelCloseButton: 'Close Banner'
};
